import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import DownloadButton from '../../DownloadButton/DownloadButton';
import XButton from '../../SocialWidgets/XButton';
import "./Article.css"

const Article = ({ articleContent }) => {
    const decodeHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.documentElement.textContent;
    };

    return (
        <Container fluid className='article'>
            <Row>
                <Col>
                    <DownloadButton item={articleContent} />
                    <XButton {...articleContent} />
                    <h3>{articleContent.title}</h3>
                </Col>
            </Row>
            <Row>
                <Col><h5>{articleContent.publishingDate.slice(0, 10)}</h5></Col>
            </Row>
            <Row>
                <Col xs={12} sm={4} md={3}><div className="thumbnail m-0 w-100"><img src={articleContent.coverUrl} alt="" className='w-100' /></div></Col>
                <Col xs={12} sm={8} md={9} className='mt-3 mt-md-0'><div className='article-description' dangerouslySetInnerHTML={{ __html: decodeHtml(articleContent.description) }} /></Col>
            </Row>
        </Container>
    )
}

export default Article